import { Maybe } from "fgr-lib-business-logic/lib/common/types"
import { CookieSerializeOptions, parse, serialize } from "cookie"

export const setCookie = (name: string, value: string, options: CookieSerializeOptions) => {
    if (typeof document === "undefined") {
        return
    }

    document.cookie = serialize(name, value, options)
}

export const deleteCookie = (name: string) => {
    if (typeof document === "undefined") {
        return
    }

    document.cookie = serialize(name, "", {
        maxAge: -1,
        path: "/",
    })
}

export const getCookie = (name: string, serverReq?: Maybe<Record<string, any>>): Maybe<string> => {
    const cookie = getCookieObject(serverReq)

    if (!cookie || !cookie[name]) {
        return null
    }

    return cookie[name]
}

const getCookieObject = (serverReq?: Record<string, any>): Maybe<Record<string, string>> => {
    if (serverReq && serverReq.headers) {
        return parse(serverReq.headers.cookie ? serverReq.headers.cookie : "")
    } else if (typeof document !== "undefined") {
        return parse(document.cookie)
    } else {
        return null
    }
}
